<template>
  <div class="component-cantidades-reservadas-sinpedido no-margin padding-top-half">
    <!--  Mensajes:
     <pre> {{ messagesResultLastMovements }} </pre>

    Pendiente de sincronizar:
    <pre> {{ transAndReprocPendingSync }} </pre> -->

    <f7-card class="content-gestion-reservas">
      <f7-card-header>
        <div class="card-header--strong">
          {{ $t('common.logisticsUnits').toUpperCase() }}
        </div>
      </f7-card-header>

      <f7-card-content class="no-padding">
        <div
          v-if="dataReservation.length < 1 && loadedContainers.length < 1"
          class="content-gestion-reservas-empty"
        >
          <p>
            {{ $t('commercialization.common.noLogisticsUnits') }}
          </p>
        </div>
        <div
          v-for="(item, index) of dataReservation"
          :key="index"
          class="content-gestion-reservas-list"
        >
          <div class="content-gestion-reservas-list__item padding-horizontal padding-vertical-half">
            <div>
              <img
                alt="iconPrint"
                src="@/static/icons/ic_print.svg"
                @click="PrintLabel(item)"
              >
              <div class="padding-left">
                <span
                  v-if="item.UnidadContenedora"
                  class="content-gestion-reservas-list__item--strong"
                >{{ item.UnidadContenedora.NumeroSerie }}</span>
                <span
                  v-else
                  class="content-gestion-reservas-list__item--strong"
                >
                  {{ $t('commercialization.common.newPallet') }}
                </span>
                <span
                  v-if="item.UnidadContenedora && item.UnidadContenedora.InfoProducto"
                  class="content-gestion-reservas-list__item--gray"
                >{{ item.UnidadContenedora.InfoProducto.Nombre }}</span>
              </div>
            </div>
            <div>
              <span class="content-gestion-reservas-list__item--gray">
                {{ $t('commercialization.common.boxesPerPallet') }}
              </span>
              <span class="content-gestion-reservas-list__item--strong">{{ item.EnvasesExistenciasUL ? item.EnvasesExistenciasUL : "-" }}</span>
            </div>
            <div>
              <span class="content-gestion-reservas-list__item--gray">
                {{ $t('commercialization.common.reservedBoxes') }}
              </span>
              <span class="content-gestion-reservas-list__item--strong">{{ item.EnvasesReservados }}</span>
            </div>
            <div class="content-gestion-reservas-list__item--buttons">
              <img
                alt="iconDelete"
                src="@/static/icons/ic_delete.svg"
                @click="RequestDeleteBookingPale(item)"
              >
              <!--
              <img
                v-if="item.Reserva != null && item.Reserva.Id !== 0"
                src="@/assets/icons/ic_AddNew.svg"
                @click="EditPale(item)"
              >
              -->
            </div>
          </div>
        </div>
        <!-- palets generados por traspasos o reprocesado -->
        <div
          v-for="(item, index) of loadedContainers"
          :key="index"
          class="content-gestion-reservas-list"
        >
          <div class="content-gestion-reservas-list__item padding-horizontal padding-vertical-half">
            <div>
              <img
                alt="iconPrint"
                src="@/static/icons/ic_print.svg"
                @click="PrintLabel(item)"
              >
              <div class="padding-left">
                <span
                  class="content-gestion-reservas-list__item--strong"
                >{{ item.UnidadContenedora.NumeroSerie }}</span>
              </div>
            </div>
            <div>
              <span class="content-gestion-reservas-list__item--gray">
                {{ $t('commercialization.common.boxesPerPallet') }}
              </span>
              <span class="content-gestion-reservas-list__item--strong">{{ item.NumeroEnvasesTotales }}</span>
            </div>
            <div>
              <span class="content-gestion-reservas-list__item--gray">
                {{ $t('commercialization.common.reservedBoxes') }}
              </span>
              <span class="content-gestion-reservas-list__item--strong">{{ item.MovimientoAlmacen.NumeroEnvases }}</span>
            </div>
            <div
              class="content-gestion-reservas-list__item--buttons"
            >
              <img
                v-if="item.TipoMovimiento !== 2"
                alt="iconDelete"
                src="@/static/icons/ic_delete.svg"
                @click="RequestDeleteWarehouseMovements(item)"
              >
            </div>
          </div>
        </div>
      </f7-card-content>
      <f7-card-footer
        class="padding-half content-buttons-picking"
      >
        <div>
          <f7-button
            v-if="showActionBtn"
            fill
            color="orange"
            @click="GestionarReserva"
          >
            {{ $t('commercialization.common.managePallet') }}
          </f7-button>
        </div>
        <div>
          <f7-button
            v-if="componentState !== 0"
            color="gray"
            @click="PressCancel"
          >
            {{ $t('common.cancel') }}
          </f7-button>
          <f7-button
            v-if="componentState !== 0"
            fill
            color="green"
            @click="Confirmation"
          >
            {{ $t('common.confirm') }}
          </f7-button>
        </div>
      </f7-card-footer>
    </f7-card>
    <UCConfirmation ref="UCConfirmation" />
  </div>
</template>

<script>
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { LogDetails as Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { ComponentState } from '@/js/common/enum';
import { TipoMovimientoPicking } from '@/js/services/traceability/enumeradosTA';
import { f7 } from 'framework7-vue';
import { useAppConfigStore } from '@/js/stores/appConfig';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { sleep } from '@/js/utils/sleep';
import { mapState } from 'pinia';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

/** @import { InfoPicking } from '@erpagroapp/types' */

export default {
  name: 'PCCantidadesReservadasSinPedido',
  components: {
    UCConfirmation,
  },

  props: {
    newDataTransfer: {
      type: Array,
      default: () => [],
    },
  },

  emits: [
    'componentStateChange',
    'manageReservation',
    'confirmation',
    'editPale',
    'cancel',
  ],

  data() {
    return {
      messagesResultLastMovements: [], // Mensajes con el último resultado al realizar traspasos o reprocesados.
      /** @type {InfoPicking[]} */
      transAndReprocPendingSync: [], // Traspasos y reprocesados pendientes de sincronizar.
      popupOpened: false,
      dataReservation: [],
      enableMultipleSimultaneousMoves: false, // Controla si se pueden hacer varios movimientos simultaneos.
      loadedContainers: [], // LISTA PALETS CREADOS POR TRASPASOS O REPROCESADOS
      replanQuantity: false,
      replanificarCantidadPaleTraspasadoOReprocesado: useParamRef('ReplanificarCantidadPaleTraspasadoOReprocesado'),
      replanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente: useSettingRef('Picking.ReplanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente'),
    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userLoginData']),

    componentState() {
      return this.transAndReprocPendingSync.length === 0
        ? ComponentState.INITIAL
        : ComponentState.EDIT;
    },
    showActionBtn() {
      if (this.enableMultipleSimultaneousMoves) {
        return true;
      }
      return this.componentState === ComponentState.INITIAL;
    },
  },

  watch: {
    newDataTransfer(val) {
      if (val.length > 0) {
        this.NewDataTransferRecibed(val);
      }
    },
    transAndReprocPendingSync(val) {
      if (val.length > 0) {
        this.$emit('componentStateChange', ComponentState.EDIT);
      } else {
        this.$emit('componentStateChange', ComponentState.INITIAL);
      }
    },
  },

  mounted() {
    this.popupOpened = false;
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.getMainData();
    },
    async getMainData() {
      Log(this, this.getMainData.name);
      const dateNow = new Date();
      const dateFormat = `${dateNow.getFullYear()}/${dateNow.getMonth() + 1}/${dateNow.getDate()}`;
      this.loadedContainers = [];
      this.getReprocessedTransferWithoutOrder(dateFormat, this.userLoginData.UserName);
    },
    ResetComponent() {
      Log(this, this.ResetComponent.name);
      this.dataReservation = [];
      this.messagesResultLastMovements = [];
      this.transAndReprocPendingSync = [];
      this.getMainData();
    },
    GestionarReserva() {
      Log(this, this.GestionarReserva.name);
      this.$emit('manageReservation');
    },
    async ProcessAndReset() {
      const result = await this.ProcessMovements();
      if (result) {
        this.ResetComponent();
        this.$emit('confirmation');
      }
    },
    async Confirmation() {
      Log(this, this.Confirmation.name);

      // Si es un  reprocesado con InfoNuevoPale se trata de una
      // base nueva por lo que debemos eliminar la información de la base.
      this.transAndReprocPendingSync.forEach((element) => {
        if (element.InfoNuevoPale != null) {
          element.UnidadContenedoraDestino = null;
        }
        if (element.LineaPedidoVenta === null) {
          element.LineaPedidoVenta = {
            Id: 0,
          };
        }
      });

      const canReplan = this.transAndReprocPendingSync.some((i) => i.LineaPedidoVentaOrigen
        && i.LineaPedidoVentaOrigen.Id !== i.LineaPedidoVenta?.Id);

      if (!this.replanificarCantidadPaleTraspasadoOReprocesado || !canReplan) {
        this.replanQuantity = false;
        this.ProcessAndReset();
      } else if (this.replanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente) {
        this.replanQuantity = true;
        this.ProcessAndReset();
      } else {
        const self = this;
        const replanQuantityDialog = f7.dialog.create({
          title: '',
          text: this.$t('commercialization.picking.info.doYouWantToReplan'),
          buttons: [
            {
              text: this.$t('common.no'),
              async onClick() {
                self.replanQuantity = false;
                await self.ProcessAndReset();
              },
            },
            {
              text: this.$t('common.yes'),
              async onClick() {
                self.replanQuantity = true;
                await self.ProcessAndReset();
              },
            },
          ],
        });
        replanQuantityDialog.open();
      }
    },
    EditPale(value) {
      Log(this, this.EditPale.name);
      this.$emit('editPale', value);
    },
    RequestDeleteBookingPale(value) {
      Log(this, this.RequestDeleteBookingPale.name);
      if (value.UnidadContenedoraOrigenTraspaso && value.UnidadContenedoraOrigenTraspaso.NumeroSerie) {
        const self = this;
        const actionsToPopover = f7.actions.create({
          buttons: [
            {
              text: self.$t('commercialization.picking.reservations.deleteActions.text', {
                serialNumber: value.UnidadContenedoraOrigenTraspaso.NumeroSerie,
              }),
              label: true,
            },
            {
              text: self.$t('commercialization.picking.reservations.deleteActions.deleteReservation'),
              bold: true,
              onClick: () => {
                self.RemoveReservationPale(value, false);
              }, // TODO No imprimir no indicar reserva
            },
            {
              text: self.$t('commercialization.picking.reservations.deleteActions.deleteReservationAndReset'),
              onClick: () => {
                self.RemoveReservationPale(value, true);
              }, // TODO indicar la Reserva que se quiere eliminar y si imprimir.
            },
            {
              text: self.$t('common.cancel'),
              color: 'red',
            },
          ],
        });
        actionsToPopover.open();
      } else {
        this.$refs.UCConfirmation.create(
          this.$t('commercialization.picking.reservations.deletePalletMerchandise.title'),
          this.$t('commercialization.picking.reservations.deletePalletMerchandise.text'),
          () => {
            this.RemoveReservationPale(value, false);
          },
        );
        this.$refs.UCConfirmation.show();
      }
    },
    RequestDeleteWarehouseMovements(item) {
      Log(this, this.RequestDeleteWarehouseMovements.name);
      const ulOrigen = item.MovimientoAlmacen.UnidadLogisticaOrigen.NumeroSerie;
      this.$refs.UCConfirmation.create(
        this.$t('commercialization.picking.reservations.removeWarehouseMovementsRequest.title'),
        this.$t('commercialization.picking.reservations.removeWarehouseMovementsRequest.text', {
          serialNumber: ulOrigen,
        }),
        () => {
          this.RemoveWarehouseMovements(item);
        },
      );
      this.$refs.UCConfirmation.show();
    },
    async RemoveWarehouseMovements(item) {
      Log(this, this.RemoveWarehouseMovements.name);
      PreloaderGH(true, true, this.$t('commercialization.picking.reservations.removeWarehouseMovements.preloaderText'), '');
      const movementWarehouse = item.MovimientoAlmacen.IdMovimientoAlmacen;
      const idUlOrigen = item.MovimientoAlmacen.UnidadLogisticaOrigen.Id;
      const result = await this.sendDeleteWarehouseMovements([movementWarehouse], idUlOrigen);
      if (!result.Valor) {
        HiNotification.Toast(this.$t('commercialization.picking.reservations.removeWarehouseMovements.error', {
          error: result.Mensaje,
        }));
        return null;
      }
      PreloaderGH(false);
      HiNotification.Toast(this.$t('commercialization.picking.reservations.removeWarehouseMovements.success'));
      this.getMainData();
      return result;
    },
    async RemoveReservationPale(info, restoreMerchandiseToOrigin) {
      Log(this, this.RemoveReservationPale.name);

      // Reservas no confirmadas
      if (!info.UnidadContenedora?.Id) {
        const index = this.dataReservation.findIndex((item) => item === info);
        if (index !== -1) {
          const indexPending = this.transAndReprocPendingSync.findIndex((item) => !!item.UnidadContenedoraDestino
            && item.UnidadContenedoraDestino.NumeroSerie === 'Nuevo Palé'
            && item.UnidadContenedoraDestino.CajasTraspasar === info.EnvasesReservados);

          if (indexPending !== -1) {
            this.transAndReprocPendingSync.splice(indexPending, 1);
          }

          this.dataReservation.splice(index, 1);
        }
        return null;
      }

      const result = await this.SENDDeleteReservation([info], restoreMerchandiseToOrigin);
      if (!result || !result.Valor) {
        HiNotification.Toast(this.$t('commercialization.picking.reservations.delete.error', {
          error: result?.Mensaje,
        }));
        return null;
      }
      HiNotification.Toast(this.$t('commercialization.picking.reservations.delete.success'));
      return result;
    },

    /**
     * @param {Record<string, any>} newData
     * @returns {void}
     */
    NewDataTransferRecibed(newData) {
      Log(this, this.NewDataTransferRecibed.name);
      if (newData.length === 0) {
        return;
      }
      const temp = newData[newData.length - 1];
      if (!temp) {
        return;
      }

      if (temp.TipoMovimiento === TipoMovimientoPicking.REPROCESADO) {
        // temp.Mercancia.forEach((m) => {
        /** @type {InfoPicking} */
        const newInforPicking = {
          TipoMovimiento: temp.TipoMovimiento,
          UnidadContenedoraDestino: temp.Base,
          UnidadContenedoraOrigen: temp.Mercancia[0],
          NumeroEnvasesTraspaso: temp.Mercancia.reduce((accumulator, object) => accumulator + object.CajasTraspasar, 0),
          LineaPedidoVenta: null,
          LineaPedidoVentaOrigen: temp.Mercancia[0].LineaPedidoVentaOrigen,
          InfoNuevoPale: temp.InfoNuevoPale,
          MercanciaAReprocesar: temp.MercanciaAReprocesar,
          ConfeccionReprocesado: temp.ConfeccionReprocesado,
        };
        this.transAndReprocPendingSync.push(newInforPicking);
        // });
        this.dataReservation.push({
          UnidadContenedora: temp.Base,
          EnvasesReservados: temp.Base !== null ? temp.Base.CajasTraspasar : 0,
        });
      } else { // Traspaso
        temp.Mercancia.forEach((m) => {
          /** @type {InfoPicking} */
          const newInforPicking = {
            TipoMovimiento: temp.TipoMovimiento,
            UnidadContenedoraDestino: temp.Base,
            UnidadContenedoraOrigen: m,
            NumeroEnvasesTraspaso: m.CajasTraspasar,
            LineaPedidoVenta: null,
            LineaPedidoVentaOrigen: m.LineaPedidoVentaOrigen,
            InfoNuevoPale: temp.InfoNuevoPale,
            MercanciaAReprocesar: null,
            ConfeccionReprocesado: null,
          };
          this.transAndReprocPendingSync.push(newInforPicking);
        });
        this.dataReservation.push({
          UnidadContenedora: temp.Base,
          EnvasesReservados: temp.Base !== null ? temp.Base.CajasTraspasar : 0,
        });
      }
    },
    async ProcessMovements() {
      Log(this, this.ProcessMovements.name);
      const result = await this.SENDDataTransferAndRepocess(
        this.replanQuantity,
        this.transAndReprocPendingSync,
      );

      if (!result || !result.Valor) {
        if (this.messagesResultLastMovements.length > 0) {
          HiNotification.Toast(this.$t('commercialization.picking.reservations.processMovements.notEmptyErrors', {
            error: this.messagesResultLastMovements[0],
          }));
        } else {
          HiNotification.Toast(this.$t('commercialization.picking.reservations.processMovements.emptyErrors'));
        }
        return false;
      }

      let numerosSerie = '';
      JSON.parse(result.Mensaje).forEach((element) => {
        if (Object.hasOwn(element.Tag, 'NumeroSerie')) {
          numerosSerie += `${element.Tag.NumeroSerie}, `;
        }
      });
      numerosSerie = numerosSerie.slice(0, -2);

      HiNotification.Toast(this.$t('commercialization.picking.reservations.processMovements.success'));
      await sleep(500);
      if (numerosSerie !== '') {
        HiNotification.Toast(this.$t('commercialization.picking.reservations.processMovements.palletsGenerated', {
          serialNumbers: numerosSerie,
        }));
      }
      this.transAndReprocPendingSync = [];
      return true;
    },

    PressCancel() {
      Log(this, this.PressCancel.name);
      this.ResetComponent();
      this.$emit('cancel');
    },
    async PrintLabel(objPale) {
      Log(this, this.PrintLabel.name);
      const result = await this.SENDPrintLabel(objPale.UnidadContenedora.Id);
      if (result) {
        HiNotification.Toast(this.$t('common.successfulPrinting'));
      } else {
        HiNotification.Toast(this.$t('common.labelCannotBePrinted'));
      }
    },

    /** */
    /** ************ CONEXIONES */
    /** */
    // obtener reservas para poder sacar el numeroSerieOrigenTraspaso

    // Traspasos y Reprocesados
    async SENDDataTransferAndRepocess(replanQuantity, lstTransferAndRepocess) {
      Log(this, this.SENDDataTransferAndRepocess.name);
      this.messagesResultLastMovements = [];

      PreloaderGH(true, true, this.$t('commercialization.picking.reservations.generatePallet.preloaderText'), '');
      try {
        const result = await ConexionTA.callGuardarTraspasosYReprocesadosPicking(replanQuantity, lstTransferAndRepocess);
        PreloaderGH(false);
        return result;
      } catch (error) {
        LogError(this, this.SENDDataTransferAndRepocess.name, error);
        PreloaderGH(false);
        return null;
      }
    },
    async SENDDeleteReservation(lstReservations, restoreMerchandiseToOrigin) {
      Log(this, this.SENDDeleteReservation.name);

      PreloaderGH(true, true, this.$t('commercialization.info.deletingReservation'), '');
      try {
        const result = await ConexionTA.callEliminarReservaDePaleLineaPedidoParaPicking(lstReservations, restoreMerchandiseToOrigin);
        PreloaderGH(false);
        return result;
      } catch (error) {
        LogError(this, this.SENDDeleteReservation.name, error);
        PreloaderGH(false);
        return null;
      }
    },
    async sendDeleteWarehouseMovements(lstMovementsId, idUlOrigen) {
      Log(this, this.sendDeleteWarehouseMovements.name);
      const result = await ConexionTA.callEliminarMovimientosAlmacenPicking(lstMovementsId, idUlOrigen);
      return result;
    },

    async SENDPrintLabel(idPale) {
      Log(this, this.SENDPrintLabel.name);
      const result = await ConexionTA.callImprimirEtiquetaPalePickingSinPedido(idPale);
      PreloaderGH(false);
      if (result.Valor) {
        return true;
      }
      return false;
    },

    async getReprocessedTransferWithoutOrder(date, user) {
      Log(this, this.getReprocessedTransferWithoutOrder.name);
      PreloaderGH(true, true, this.$t('commercialization.picking.reservations.getReprocessedTransferWithoutOrder.preloaderText'), '');
      const result = await ConexionTA.callObtenerUltimosPalesTraspasadosReprocesadosSinPedido(user, date);
      if (result.Valor) {
        this.loadedContainers = result.Tag;
      } else {
        HiNotification.Toast(result.Mensaje ? result.Mensaje
          : this.$t('commercialization.picking.reservations.getReprocessedTransferWithoutOrder.error'));
      }
      PreloaderGH(false);
    },
  },
};
</script>

<style scoped lang="scss">
.component-cantidades-reservadas-sinpedido {
  background: #ebecf0;
}

.content-gestion-reservas {
  .card-header {
    background-color: #ebecf0;
    --f7-card-header-font-weight: 400;
    --f7-card-header-font-size: 14px;
    --f7-card-header-text-color: var(--his-ajo);

    &--gray {
      color: var(--his-ajo-light);
    }

    &--strong {
      font-weight: 700;
    }

    &--large {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .card-content {
    height: calc(90vh - 100px);
    overflow-y: scroll;

    @media (max-height: 550px) {
      height: calc(100vh - 110px) !important;
      max-height: 180px;
    }
  }

  .content-gestion-reservas-empty {
    display: flex;
    height: 90%;
    justify-content: space-around;
    align-items: center;

    p {
      font-size: 16px;
      font-weight: 600;
      color: var(--his-ajo);
    }
  }

  .content-gestion-reservas-list {
    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ebecf0;

      &--strong {
        color: var(--his-steel-blue);
        font-size: 20px;
        font-weight: 700;
      }

      &--gray {
        color: var(--his-oliva);
        font-size: 14px;
        font-weight: 400;
      }

      >div:first-child {
        display: flex;
        align-items: center;

        >div {
          display: flex;
          flex-direction: column;
        }
      }

      >div:not(:first-child) {
        display: flex;
        flex-direction: column;
      }

      &--buttons {
        min-width: 42px;
        flex-direction: row !important;

        img:first-child {
          margin-right: 10px;
        }
      }
    }
  }

  .card-footer {
    background-color: #ebecf0;
  }
}

.content-buttons-picking {
  display: flex;
  justify-content: space-between;

  >div {
    text-decoration: none;
    display: flex;

    .button {
      width: 120px;

      &:first-child {
        margin-right: 10px;
      }
    }
  }

  >div:first-child {
    .button {
      width: 170px;
    }
  }
}

.content-grid {
  display: grid;
  row-gap: 2vh;
  grid-template-columns: 0.8fr 2fr 1.2fr;
  column-gap: 1vw;
}

.content-grid > div:nth-child(1) {
  grid-column: span 1;
}

.content-grid > div:nth-child(2) {
  grid-column: span 1;
  grid-row: 2 span;
}

.main-picking,
.panel {
  .badge {
    height: 22px;
    width: 22px;
    font-size: 15px;
    background: #e4e4e4;
    color: var(--his-metal);
    font-weight: 500;
  }

  .content-list-checkbox-item,
  .content-title-select {
    padding: 7px 15px;
    background: #f4f5f7;
    margin-bottom: 2px;
    border: 1px solid #ebebed;
    border-radius: 3px;

    &.incidence {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #ff5630;
    }

    &.out-of-line {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #fcff30;
    }
  }

  .content-list-checkbox-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > div {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    label {
      margin-right: 10px;
    }

    &__details {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;

      &--title {
        color: var(--his-dark-blue);
      }

      &--subtitle {
        color: var(--his-kiwi-pulp);
        text-transform: uppercase;
      }

      img {
        border-radius: 50%;
        margin: 0 10px 0 0;
        width: 64px;
        height: 64px;
      }

      &--total {
        display: flex;

        img {
          height: 20px;
          width: 20px;
          margin: 0;
          padding: 0 0 0 5px !important;
          border-radius: 0;
        }
      }
    }

    &__time {
      color: var(--his-slate-blue);
      font-size: 28px;
      display: flex;
      align-items: center;

      &::after {
        font-family: "framework7-core-icons";
        font-weight: normal;
        direction: ltr;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        -moz-font-feature-settings: "liga";
        font-feature-settings: "liga";
        text-align: center;
        display: block;
        margin-left: 15px;
        font-size: var(--f7-list-chevron-icon-font-size);
        color: var(--f7-list-chevron-icon-color);
        pointer-events: none;
        right:
          calc(
            var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-right)
          );
        content: var(--f7-list-chevron-icon-right);
      }
    }

    &.checked {
      background-color: var(--his-steel-blue);
      color: #fff;

      .badge {
        background-color: #253858;
        color: #fff;
      }
    }
  }

  .content-title-select {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__input {
      display: flex;
      align-items: center;
      color: var(--his-steel-blue);
      font-weight: 500;
      font-size: 15px;
      text-transform: uppercase;

      label {
        margin-right: 12px;
      }
    }
  }

  .content-new-activity {
    &__datetime {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        width: 100%;
      }

      > div:first-child {
        margin-right: 15px;
      }

      > div:nth-child(2) {
        max-width: 120px !important;
      }

      input {
        color: var(--his-dark-blue);
        font-weight: 500;
        font-size: 16px;
      }
    }
  }

  label.item-checkbox input[type="checkbox"]:checked ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:checked ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:checked ~ i,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:indeterminate ~ i {
    background-color: #566784;
    border-color: #566784;
    zoom: 1.3;
  }

  .icon-checkbox {
    zoom: 1.3;
  }

  .actions-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

a.panel-close {
  background: var(--his-dark-blue);
  display: flex;
}

.ios .icon-checkbox,
.ios .checkbox i {
  zoom: 1.1 !important;
}

@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr 2fr;
  }

  .content-logo-hispatec {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr 3fr !important;
  }
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 530px) {
  .content-logo-company {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr !important;
  }

  .content-list-checkbox-item__details {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .content-list-checkbox-item__time {
    font-size: 18px !important;
    font-weight: 600;
    padding-left: 10px;
  }

  .content-list-checkbox-item__details img.avatar-round {
    width: 48px !important;
    height: 48px !important;
  }
}

.span-text-error {
  color: red;
  font-size: 11px;
  opacity: 0.7;
}

.content-list-checkbox-scroll {
  height: 72vh;
  overflow-y: auto;
}

.campo_New {
  margin-bottom: 10px;
  background: var(--his-bg);
  border: 1px solid rgb(212 212 212 / 29.9%);
  box-sizing: border-box;
  border-radius: 6px;
  list-style-type: none;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.campo_Cantidad-input {
  background: var(--his-tierra-white);
  border: 0.78125px solid var(--his-silver);
  border-radius: 6.25px;
  margin-left: 10px !important;
  margin-right: 10px !important;
  margin-top: 6px;
}

.campo_Fecha-input {
  margin-right: 5px !important;
  margin-left: 10px !important;
  padding: 0 !important;
}

.campo_Hora-input {
  margin-right: 10px !important;
  margin-left: 5px !important;
  padding: 0 !important;
}

.style_Text_Outline {
  font-weight: 700;
  font-size: 14px;
  color: var(--his-steel-blue);
}

.style_Text_Outline2-3 {
  font-weight: 400;
  font-size: 14px;
  color: var(--his-steel-blue);
}

.content_card {
  background: #ebecf0;
  padding-left: 0;
  padding-right: 0;
}

.style_Title1 {
  left: 10.85%;
  right: 70.93%;
  top: 24.29%;
  bottom: 42.86%;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: var(--his-steel-blue);
}

.style_Title2 {
  left: 40.44%;
  right: 48.06%;
  top: 15.71%;
  bottom: 58.57%;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--his-oliva);
}

.content_Field1 {
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: var(--his-oliva);
}

.content_Field2-3 {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: var(--his-steel-blue);
}

.background_icon_Imprimir {
  left: 2.33%;
  right: 91.47%;
  top: 17.14%;
  bottom: 14.29%;
  background: var(--his-steel-blue);
}

.button1 {
  width: 209px;
  background: var(--his-mandarina);
  border-radius: 6px;
  margin-left: 10px;
}

.style_Text1 {
  position: static;
  font-weight: 500;
  letter-spacing: 0.85px;
  color: #fff;
}

.button2 {
  width: 209px;
  border: 1px solid;
  border-color: var(--his-metal);
  background: #ebecf0;
}

.style_Text2 {
  position: static;
  font-weight: 500;
  letter-spacing: 0.85px;
  color: var(--his-metal);
}

.button3 {
  margin-left: 100px;
  background: var(--his-greendark);
  border-radius: 6px;
  margin-right: 10px;
}

.style_Text3 {
  position: static;
  font-weight: 500;
  letter-spacing: 0.85px;
  color: #fff;
}

.menu {
  background-color: #ebecf0;
  box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
  width: 80px;
}

.scanner-Data {
  margin-top: 30px;
  font-size: 18px;
  color: var(--his-oliva);
}

.cancel-btn {
  width: 146px;
  background: #ebecf0;
  color: var(--his-metal);
  text-align: center;
}
</style>
